<template>
    <div>
        <div class="planning-section-title text-center pd-top-120 pd-bottom-110">
            <div class="planning-section-title-left">
                <router-link to="/" style="cursor:default">Calidad. </router-link>
                <router-link to="/" style="cursor:default">Solución. </router-link>
                <router-link to="/" style="cursor:default">Compromiso. </router-link>              
                <router-link to="/" style="cursor:default">Éxito. </router-link>        
                <router-link to="/" style="cursor:default">Crecimiento . </router-link>
            
            </div>
            <div class="planning-section-title-right">
                <router-link to="/" style="cursor:default">Innovador. </router-link>
                <router-link to="/" style="cursor:default">Experto. </router-link>
                <router-link to="/" style="cursor:default">Confiable. </router-link>
                <router-link to="/" style="cursor:default">Eficiente. </router-link>
                <router-link to="/" style="cursor:default">Óptimo . </router-link>


            </div>
        </div>
        <div class="planning-area bg-sky pd-top-120 pd-bottom-120">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="section-title mb-0 mt-5 mt-lg-0">
                            <h6 class="sub-title wow animated fadeInUp" data-wow-duration="1.5s" data-wow-delay="0.1s">Misión</h6>
                            <h2 class="title mb-4 wow animated fadeInUp" data-wow-duration="1.5s" data-wow-delay="0.15s">servicios personalizados de acuerdo a tus necesidades</h2>
                            <p style="text-align: justify;" class="content wow animated fadeInUp" data-wow-duration="1.5s" data-wow-delay="0.2s">En Smaco, nos dedicamos a ofrecer soluciones de software innovadoras y de alta calidad que impulsen el éxito y la transformación digital de nuestros clientes. 
                            Nuestro compromiso es proporcionar servicios personalizados y adaptados a las necesidades de cada cliente, utilizando tecnologías de vanguardia y enfoques ágiles para garantizar la satisfacción y el crecimiento continuo de nuestros socios comerciales."</p>
                            <br>
                            <img class="wow animated fadeInUp" data-wow-duration="1.5s" data-wow-delay="0.3s" :src="require('@/assets/img/about/smaco-12.jpg')" alt="img">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-9 mt-4 mt-lg-0 align-self-center" style="padding-left: 4% ;">
                        
                            <div class="section-title mb-0 mt-5 mt-lg-0">
                                <img class="wow animated fadeInUp" data-wow-duration="1.5s" data-wow-delay="0.3s" :src="require('@/assets/img/about/smaco-7.jpg')" alt="img"><br><br>
                                <h6 class="sub-title wow animated fadeInUp" data-wow-duration="1.5s" data-wow-delay="0.1s">Visión</h6>
                                <h2 class="title mb-4 wow animated fadeInUp" data-wow-duration="1.5s" data-wow-delay="0.15s">Reconocimiento en el desarrollo de software</h2>
                                <p style="text-align: justify;" class="content wow animated fadeInUp" data-wow-duration="1.5s" data-wow-delay="0.2s">Nuestra visión es convertirnos en un referente en el desarrollo de software, reconocidos por nuestra excelencia en la entrega de soluciones innovadoras y por nuestro enfoque centrado en el cliente. Buscamos establecer relaciones a largo plazo con nuestros clientes, ser un empleador de elección para los profesionales de la tecnología y contribuir positivamente al crecimiento y desarrollo de las empresas con las que trabajamos</p>
                            </div>
                       
                    </div>    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Planning",
    }
</script>


// WEBPACK FOOTER //
// src/components/page/home/Planning.vue